import React, { useEffect, useState } from "react";
import {TbMinusVertical} from 'react-icons/tb';
import {FaUserAlt} from 'react-icons/fa';
import {BsCalendarDate} from 'react-icons/bs';
import {FiSearch } from 'react-icons/fi';
import {GrMenu } from 'react-icons/gr';
import "./HomeImgComp.css";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import DialogComp from './DialogComp.js';
import { Link } from "react-router-dom";
// import AOS from "aos";
// import "aos/dist/aos.css";
import Fade from 'react-reveal/Fade';
import logo from './logo-removebg-preview.png'
var cart = "a";

const HomeImgComp = ({ type }) => {
  const [skeletonScreen, setSkeletonScreen] = useState(false);
  useEffect(() => {
    if (cart == "a") {
      setSkeletonScreen(true);
      setTimeout(() => {
        cart = "b";
        setSkeletonScreen(false);
      }, 5000);
    }
  }, []);

  const [destination, setDestination] = useState("");
  const [openDate, setOpenDate] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [scrollY,setScrollY] = useState(window.scrollY)

  window.addEventListener('scroll',()=>{
    console.log('window screen scrollY==>',window.scrollY)
    setScrollY(window.scrollY)
  })
  
  // if(window.outerWidth>550 && scrollY<275 && scrollY>265){
  //   setCond1(true);
  //   setTimeout
  // }

  const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };

  const [date, setDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [openOptions, setOpenOptions] = useState(false);
  const [options, setOptions] = useState({
    adult: 1,
    children: 0,
    room: 1,
  });

  const navigate = useNavigate();

  const handleOption = (name, operation) => {
    setOptions((prev) => {
      return {
        ...prev,
        [name]: operation === "i" ? options[name] + 1 : options[name] - 1,
      };
    });
  };

  const handleSearch = () => {
    navigate("search");
  };


console.log("skeletonScreencart",cart)
console.log("skeletonScreen",skeletonScreen)

  return (
    <div className="header" onClick={()=>{
        if(openDate){
          setOpenDate(false)
        }
        if(openOptions){
          setOpenOptions(false)
        }
    }}>
      <DialogComp  handleClickOpen={handleClickOpen} handleClose={handleClose} open={open} />
      <div
        className={
          type === "list" ? "headerContainer listMode" : "headerContainer"
        }
      >

        {type !== "list" && (
          <>
          <GrMenu className=' stickey searchModalIcon'  onClick={()=>handleClickOpen()} />
            <div 
            // className= "headerSearch"
            className={(scrollY<245 || window.outerWidth<551) ?  "headerSearch" : 'headerSearch headerSearchFixed'}
            // className={window.outerWidth>550 ? (scrollY>250 && scrollY<300) ? 'headerSearch firstFixed' : (scrollY>=300) ? 'headerSearch secondFixed' : 'headerSearch' : "headerSearch"}

>
              <div className="headerSearchItem headerSearchItem1">
              {(scrollY<245 || window.outerWidth<551) ? null:
              <div style={{height:57, width:'100%', textAlign: 'left',}}>
                  <img  onClick={()=>{ window.scrollTo(0, 0);}} style={{height:57, marginRight:10, cursor:'pointer'}} src={logo}/>
                <TbMinusVertical className='vert1' fontSize={50} style={{position:'relative',right:0,opacity:0.3}} color={'gray'} />
                </div>
                }

                <div style={{display:'flex',flexDirection:'column'}}>
                <span style={{color:'black',textAlign:'left', fontWeight: "500",}}>Location</span>
                <input
            className={(scrollY<245 || window.outerWidth<551) ?  "headerSearchInput" : 'headerSearchInput input-color-change'}

                  type="text"
                  placeholder="Where are you going?"
                  // className="headerSearchInput"
                  onChange={(e) => setDestination(e.target.value)}
                />
                </div>
              <TbMinusVertical className='vert1' fontSize={50} style={{position:'relative',left:20,opacity:0.3}} color={'gray'} />
              </div>
              <div className="headerSearchItem headerSearchItem2">
              <div style={{display:'flex',flexDirection:'column'}}
              onClick={e=>e.stopPropagation()}>
                <span style={{color:'black',textAlign:'left',  fontWeight: "500",}}>Check in - Check out</span>
                <span
                  onClick={() =>{
                    setOpenDate(!openDate)
                    setOpenOptions(false)
                  }}
                  className="headerSearchText"
                >{`${format(date[0].startDate, "MM/dd/yyyy")} - ${format(
                  date[0].endDate,
                  "MM/dd/yyyy"
                )}`}</span>
                 {/* <span
                  onClick={() => setOpenDate(!openDate)}
                  className="headerSearchText"
                >{`${format(date[0].startDate, "dd/MMM")}  -  ${format(
                  date[0].endDate,
                  "dd/MMM"
                )}`}</span> */}
                {openDate && (
                  <DateRange
                    editableDateInputs={true}
                    onChange={(item) => setDate([item.selection])}
                    moveRangeOnFirstSelection={false}
                    ranges={date}
                    // className="date"
            className={(scrollY<245 || window.outerWidth<551) ?  "date" : 'date dateNew'}
                    minDate={new Date()}
                  />
                )}
                </div>
              <TbMinusVertical className='vert1' fontSize={50} style={{position:'relative',left:20,opacity:0.3}} color={'gray'} />
              </div>
              <div className="headerSearchItem headerSearchItem3">
              <div style={{display:'flex',flexDirection:'column'}}>
                <span style={{color:'black',textAlign:'left',  fontWeight: "500",}}>Guests</span>

                <span
                  onClick={(e) => {
                    setOpenOptions(!openOptions)
                    setOpenDate(false)
                  }}
                  style={{zIndex:2}}
                  className="headerSearchText"
                >{`${options.adult} adult · ${options.children} children · ${options.room} room`}</span>
                {openOptions && (
                  <div 
                  // className="options" 
                  className={(scrollY<245 || window.outerWidth<551) ?  "options" : 'options optionsNew'}        
                  onClick={(e)=>e.stopPropagation()}>
                    <div className="optionItem">
                      <span className="optionText">Adult</span>
                      <div className="optionCounter">
                        <button
                          disabled={options.adult <= 1}
                          className="optionCounterButton"
                          onClick={() => handleOption("adult", "d")}
                        >
                          -
                        </button>
                        <span className="optionCounterNumber">
                          {options.adult}
                        </span>
                        <button
                          className="optionCounterButton"
                          onClick={() => handleOption("adult", "i")}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="optionItem">
                      <span className="optionText">Children</span>
                      <div className="optionCounter">
                        <button
                          disabled={options.children <= 0}
                          className="optionCounterButton"
                          onClick={() => handleOption("children", "d")}
                        >
                          -
                        </button>
                        <span className="optionCounterNumber">
                          {options.children}
                        </span>
                        <button
                          className="optionCounterButton"
                          onClick={() => handleOption("children", "i")}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="optionItem">
                      <span className="optionText">Room</span>
                      <div className="optionCounter">
                        <button
                          disabled={options.room <= 1}
                          className="optionCounterButton"
                          onClick={() => handleOption("room", "d")}
                        >
                          -
                        </button>
                        <span className="optionCounterNumber">
                          {options.room}
                        </span>
                        <button
                          className="optionCounterButton"
                          onClick={() => handleOption("room", "i")}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                )}
            </div>
              {/* <TbMinusVertical fontSize={50} style={{position:'relative',left:20,opacity:0.3}} color={'gray'} /> */}
              </div>
              <div className="headerSearchItem">
                <button 
            className={(scrollY<245 || window.outerWidth<551) ?  "headerBtn" : 'headerBtn headerBtnMargin'}
                
                // className="headerBtn"
                 onClick={handleSearch}>
                  <FiSearch/>
                </button>
              </div>
            </div>

            <div
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-once="true"
            // data-aos={cart!="b"?"fade-up":""} 
            // data-aos-duration={cart!="b"?"1200":"0"}
            
            >
               <h1 
                 className={(scrollY<245 || window.outerWidth<551) ?  "imgCompHead  imgCompHead-top " : 'imgCompHead  imgCompHead-top  headingmargin'}
              //  className="imgCompHead  imgCompHead-top "
               >Not sure where to</h1>
               <h2 className="imgCompHead  imgCompHead-bottom"> go ? Perfect</h2>
               <Link to="search" className="flexibleExpCompHome">
                 Explore
               </Link>
             </div>

          </>
        )}
      </div>
    </div>
  );
};

export default HomeImgComp;
